export const ENTER_SITE = 'enterSite'
export const EXIT_SITE = 'exitSite'
